/*
 * Sacred Essence - quick add to cart from the home page product cards.
 *
 * Adds the product's first available variant via the AJAX cart API, then tells
 * Horizon the cart changed so the header bubble updates without a page reload.
 * Horizon's cart-icon component listens for 'cart:update' and reads
 * detail.data.itemCount (see assets/cart-icon.js).
 */
(function () {
  var RESET_MS = 1800;

  function restore(button, label) {
    button.classList.remove('is-loading', 'is-done');
    button.textContent = label;
    delete button.dataset.busy;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.se-add');
    if (!button || button.disabled) return;

    event.preventDefault();
    if (button.dataset.busy) return;
    button.dataset.busy = '1';

    var label = button.textContent;
    button.classList.add('is-loading');
    button.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.vid), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return fetch('/cart.js');
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'se-quick-add',
              data: { source: 'se-quick-add', itemCount: cart.item_count }
            }
          })
        );

        button.classList.remove('is-loading');
        button.classList.add('is-done');
        button.textContent = 'Added to cart';
        setTimeout(function () {
          restore(button, label);
        }, RESET_MS);
      })
      .catch(function () {
        button.classList.remove('is-loading');
        button.textContent = 'Try again';
        setTimeout(function () {
          restore(button, label);
        }, RESET_MS);
      });
  });
})();
